import client from './client';

export async function fetchReport(type, params) {
  const { data } = await client.get(`/reports/${type}`, { params });
  return data.data;
}

export async function exportReport(type, params) {
  return client.get(`/reports/${type}/export`, { params, responseType: 'blob' });
}
